import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
// DS: DS4.1
/** A styled radio button control for forms */ import React from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import s from './RadioButton.scss';
const RadioButton = (_param)=>{
    var { className , inputClassName , children , withMargins =false , size ='medium' , biData  } = _param, rest = _object_without_properties(_param, [
        "className",
        "inputClassName",
        "children",
        "withMargins",
        "size",
        "biData"
    ]);
    return /*#__PURE__*/ React.createElement("label", {
        className: c(s['root'], withMargins && s['with-margins'], children && s['with-children'], s[size], className)
    }, /*#__PURE__*/ React.createElement(BiInput, _extends({
        type: "radio",
        biData: biData,
        className: inputClassName
    }, rest)), children);
};
RadioButton.displayName = 'RadioButton';
export default RadioButton;
